import { TABLA_REPORTE_EMBARQUE_SECTOR_5 } from '../../../../../config/tables'
import { COLUMNS_REPORTE_EMBARQUE_SECTOR_5_TO_PRINT, COLUMNS_REPORTE_EMBARQUE_SECTOR_5 } from './constantesReporteEmbarqueSector5'
import { pdfCustomToolbarGenerator } from '../../../../../models/tools/generarPdf'
import { ReporteEmbarqueSector5Service } from '../../../../../models/movimiento/ReporteEmbarquePorSector/tabla_reporte_embarque_sector_5'

export function actualizarDatosParaMuiTable (cereal, cerealVariedad, etiqueta) {
  return dispatch => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLA_REPORTE_EMBARQUE_SECTOR_5
    })
    const promiseReporteEmbarqueSector5 = ReporteEmbarqueSector5Service.getDataReporteEmbarqueSector5(cereal, cerealVariedad, etiqueta)
    const promiseReporteEmbarqueSector5Total = ReporteEmbarqueSector5Service.getDataReporteEmbarqueSector5Total(cereal, cerealVariedad, etiqueta)
    Promise.all([promiseReporteEmbarqueSector5, promiseReporteEmbarqueSector5Total]).then(callback)
    function callback (dataArray) {
      const dataCombinada = dataArray[0].filas || []
      const filaTotalArreglada = (dataArray[1] || [])[0] || {}
      filaTotalArreglada['cereal'] = 'Total'
      dataCombinada.push(filaTotalArreglada)
      const customToolbar = pdfCustomToolbarGenerator(
        'Reporte Embarque Sector 5',
        dataCombinada,
        COLUMNS_REPORTE_EMBARQUE_SECTOR_5_TO_PRINT,
        'portrait')
      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          columns: COLUMNS_REPORTE_EMBARQUE_SECTOR_5,
          data: dataCombinada,
          title: `Reporte Embarque Sector 5`,
          isLoading: false,
          fixed2Decimales: false,
          extraOptions: { customToolbar, print: false }
        },
        id: TABLA_REPORTE_EMBARQUE_SECTOR_5
      })
    }
  }
}
